const invoicesHR = {
    "view": {
        "table": {
            "title": "Popis vaših računa",
            "column": {
                "issueDate": "Datum izdavanja",
                "invoiceNumber": "Broj računa",
                "status": "Status",
                "totalAmount": "Ukupan iznos",
                "downloadPDF": "Preuzmi PDF",
                "whtStatement": "Izjava o porezu po odbitku"
            },
            "label": {
                "notApplicable": "Nije primjenjivo"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "button": {
                "download": "Preuzmi",
                "exportCSV": "Izvoz CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Nažalost, trenutno ne možete dodavati račune. Ili vaši porezni ili podaci o platnom računu nisu u potpunosti dovršeni. Da biste otključali ovu značajku, molimo kontaktirajte naš tim za podršku.",
            "invoicingNotAvailable": "Generirajte račune od 3. do 22. svakog mjeseca. Imajte na umu da generiranje računa nije moguće od 23. do 2. sljedećeg mjeseca, jer se tijekom ovog razdoblja obavljaju automatske plaćanja. Hvala na razumijevanju.",
            "generatingInvoices": "Trenutno ne možete dodavati račune jer imate račune koji se trenutno generiraju. Molimo provjerite kasnije.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku."
        }
    },
    "add": {
        "title": "Dodaj račun",
        "form": {
            "table": {
                "statements": {
                    "title": "Izjave dostupne za fakturiranje"
                }
            },
            "button": {
                "generateInvoice": "Generiraj račun"
            }
        },
        "message": {
            "success": "Račun je dodan!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "noStatementAvailable": "Nema dostupnih izjava za fakturiranje.",
            "invoicingLimitNotReached": "Ne možete trenutno dodavati račune jer ukupan iznos za plaćanje je manji ili jednak <strong>0€</strong>."
        },
        "modal": {
            "header": "Dodaj račun",
            "body": "Jeste li sigurni da želite kreirati račun za trenutno OTVORENE izjave?"
        }
    }
};

export default invoicesHR;